import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TitleChangedAction} from '../../../core/actions/title.actions';
import {AsideService} from '../../../core/services/aside.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'motn-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
  ],
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private asideService: AsideService,
    private store: Store<AppState>,
  ) {
  }


  ngOnInit(): void {
    this.updateTitle();
    this.updateAside();
  }


  private updateTitle() {
    this.store.dispatch(new TitleChangedAction(
      'location-question',
      'Hmm...',
    ));
  }


  private updateAside() {
    this.asideService.replaceContextSections([]);
  }
}
